/**
 * Ambient Photo Crop Service
 * Handles API calls for ambient photo crop processing
 */

import { api } from '@/lib/axios';

interface CropData {
  x: number;
  y: number;
  width: number;
  height: number;
}

interface AmbientPhotoCropResponse {
  id: string;
  blob_id: string;
  crop_data: CropData | null;
  status: 'raw' | 'processing' | 'ready' | 'error';
  processed_blob_id: string | null;
  optimization_status: string;
  processed_at: string | null;
  created_at: string;
  updated_at: string;
}

/**
 * Update ambient photo crop data
 * Sends crop coordinates and viewport position to backend for processing
 */
export async function updateAmbientPhotoCrop(
  photoId: string,
  attachmentId: string,
  cropData: CropData,
  viewportPosition: { x: number; y: number }
): Promise<AmbientPhotoCropResponse> {
  const response = await api.patch(
    `/v1/admin/ambient_photos/${photoId}/crop`,
    {
      crop_data: cropData,
      viewport_position: viewportPosition,
    }
  );

  return response.data;
}
